import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdgeTrimmingSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "edge_trimming-sm" }), /* @__PURE__ */ _jsxs("g", {
		id: "Layer_2",
		"data-name": "Layer 2",
		children: [
			/* @__PURE__ */ _jsx("path", {
				className: "icon-white",
				d: "M50,29.82,15.11,50l-3.63,2.09a5.26,5.26,0,0,0-1.91,2.13,6.78,6.78,0,0,0-.89,3.21v8.2l41.57,24L91.56,65.74V53.82Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M92.65,53.1a1.19,1.19,0,0,0-.61-1h0l-42-23.3a1.22,1.22,0,0,0-1.2,0L10.74,51.68A6.38,6.38,0,0,0,8.42,54.3a8,8,0,0,0-1,3.81l.14,8.2a1.19,1.19,0,0,0,.61,1l42,23.29a1.15,1.15,0,0,0,.6.16,1.27,1.27,0,0,0,.6-.18l40.9-24.54a1.19,1.19,0,0,0,.58-1ZM90.44,64.37,51.81,87.55a1.19,1.19,0,0,0-2.19,0L10,65.58l-.13-7.51a5.6,5.6,0,0,1,.7-2.66A4,4,0,0,1,12,53.74L49.51,31.21,90.26,53.83Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M85.05,58.17a1.16,1.16,0,0,0,.6-.17l3.29-2A1.2,1.2,0,1,0,87.71,54l-3.29,2A1.21,1.21,0,0,0,84,57.59,1.22,1.22,0,0,0,85.05,58.17Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M71.88,66.07a1.16,1.16,0,0,0,.6-.17l3.29-2a1.2,1.2,0,1,0-1.23-2.06l-3.29,2a1.2,1.2,0,0,0,.63,2.23Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M65.3,70a1.16,1.16,0,0,0,.6-.17l3.29-2a1.24,1.24,0,0,0,.55-.74,1.26,1.26,0,0,0-.14-.91A1.19,1.19,0,0,0,68,65.82l-3.29,2a1.24,1.24,0,0,0-.55.74,1.21,1.21,0,0,0,.14.91A1.19,1.19,0,0,0,65.3,70Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M78.47,62.12a1.16,1.16,0,0,0,.6-.17l3.29-2a1.2,1.2,0,0,0,.55-.73,1.25,1.25,0,0,0-.14-.91,1.21,1.21,0,0,0-.74-.55,1.17,1.17,0,0,0-.91.14l-3.29,2a1.24,1.24,0,0,0-.55.74,1.26,1.26,0,0,0,.14.91A1.21,1.21,0,0,0,78.47,62.12Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M49.5,80.19a8.42,8.42,0,0,0-.09,1.21l.05,2.83a1.2,1.2,0,0,0,2.4,0l0-2.83a5.46,5.46,0,0,1,.06-.79,1.17,1.17,0,0,0-.21-.89,1.2,1.2,0,0,0-2.16.51Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M58.71,74a1.16,1.16,0,0,0,.6-.17l3.29-2a1.2,1.2,0,0,0-1.23-2.06l-3.29,2A1.19,1.19,0,0,0,58.71,74Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M52.28,78.12a1.18,1.18,0,0,0,.89-.42,3.26,3.26,0,0,1,.76-.67L56,75.78a1.24,1.24,0,0,0,.55-.74,1.26,1.26,0,0,0-.14-.91,1.17,1.17,0,0,0-.74-.54,1.21,1.21,0,0,0-.91.13L52.7,75a5.65,5.65,0,0,0-1.35,1.17,1.21,1.21,0,0,0,.13,1.7A1.17,1.17,0,0,0,52.28,78.12Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M41.46,71.59a.58.58,0,0,0,.42.56l2.11.61a3.9,3.9,0,0,1,2.69,2.68l.6,2.11a.58.58,0,0,0,.56.42h0a.58.58,0,0,0,.56-.42L49,75.44a3.89,3.89,0,0,1,2.68-2.68l2.11-.61a.57.57,0,0,0,.42-.56A.58.58,0,0,0,53.8,71l-2.11-.61A3.87,3.87,0,0,1,49,67.74l-.61-2.11a.58.58,0,0,0-.56-.42h0a.59.59,0,0,0-.56.42l-.6,2.11A3.88,3.88,0,0,1,44,70.42L41.88,71A.59.59,0,0,0,41.46,71.59Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M54.23,75.94s0-.06,0-.11l0-.12,0-.1,0-.11,0,0,0,0a1,1,0,0,1-.08-.11l-.08-.08-.08-.08-.11-.07-1.72-1a1.18,1.18,0,0,0-.9-.12,1.22,1.22,0,0,0-.74.56,1.21,1.21,0,0,0,.44,1.64l.22.12a8.53,8.53,0,0,0-1.7,3.32L9.92,56.85a5.9,5.9,0,0,1,.7-2.11,5,5,0,0,1,.93-1.25L14.2,55a1.24,1.24,0,0,0,1.64-.44,1.21,1.21,0,0,0-.44-1.64L12,51l-.1,0-.12,0-.11,0-.12,0h-.33l-.12,0L11,51l-.11,0-.05,0a6.49,6.49,0,0,0-2.35,2.57,8,8,0,0,0-1,3.8v.14a1.19,1.19,0,0,0,.6,1l41.57,24a1.21,1.21,0,0,0,1.2,0,1.2,1.2,0,0,0,.6-1v-.13a5.44,5.44,0,0,1,2.19-4.29l.22-.17,0-.06a.91.91,0,0,0,.13-.16l.05-.09a.61.61,0,0,0,0-.12.42.42,0,0,0,0-.1s0-.07,0-.12,0-.07,0-.11v-.23Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M37.47,68.46l3.33,1.92a1.25,1.25,0,0,0,.6.16A1.2,1.2,0,0,0,42,68.3l-3.33-1.92a1.2,1.2,0,0,0-1.2,2.08Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M17.52,56.94l3.33,1.92a1.25,1.25,0,0,0,.6.16,1.22,1.22,0,0,0,1-.6,1.21,1.21,0,0,0-.44-1.64l-3.33-1.92a1.21,1.21,0,0,0-.91-.12,1.18,1.18,0,0,0-.73.56A1.21,1.21,0,0,0,17.52,56.94Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M30.82,64.62l3.33,1.92a1.25,1.25,0,0,0,.6.16,1.22,1.22,0,0,0,1-.6,1.2,1.2,0,0,0-.44-1.64L32,62.54a1.2,1.2,0,0,0-.91-.12,1.18,1.18,0,0,0-.73.56A1.21,1.21,0,0,0,30.82,64.62Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M24.17,60.78,27.5,62.7a1.25,1.25,0,0,0,.6.16,1.22,1.22,0,0,0,1-.6,1.21,1.21,0,0,0-.44-1.64L25.37,58.7a1.2,1.2,0,0,0-.91-.12,1.18,1.18,0,0,0-.73.56A1.21,1.21,0,0,0,24.17,60.78Z"
			})
		]
	})]
});
export default SvgEdgeTrimmingSm;
